var map = {
	"./alerts_white.svg": "774d",
	"./calendar_white.svg": "a4e6",
	"./conflict_white.svg": "b98e",
	"./crime_white.svg": "af35d",
	"./disasters_white.svg": "9da2",
	"./elections_white.svg": "1474",
	"./events_white.svg": "ccd7",
	"./health_white.svg": "a784",
	"./layers_white.svg": "acbf",
	"./media_white.svg": "f86e",
	"./person_white.svg": "794b",
	"./places2_white.svg": "80c6",
	"./places_white.svg": "ed88",
	"./political_terrorism_white.svg": "c7ed",
	"./profile_white.svg": "7a09",
	"./pulse_white.svg": "9e0b",
	"./terrorism_white.svg": "f61c",
	"./transportation_white.svg": "9f4f",
	"./travel_tracker_white.svg": "c93c",
	"./travel_white.svg": "274a",
	"./unrest_white.svg": "9cff",
	"./war_white.svg": "4502"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e3cb";